// "Is a newer build installed and waiting?" — as state, for surfaces that only
// need to reflect it rather than prompt about it.
//
// Separate from useServiceWorkerUpdate, which owns the one-shot toast and its
// don't-interrupt policy. The version badge has no such policy: it should just
// show a dot whenever a build is waiting, including after the toast has been
// dismissed — that dismissal is what left the old UI with no route to the
// update at all.

import { useEffect, useState } from "react";
import {
  isUpdateWaiting,
  onUpdateReady,
} from "../serviceWorkerRegistration";

export function useUpdateWaiting() {
  const [waiting, setWaiting] = useState(isUpdateWaiting);

  useEffect(() => onUpdateReady(() => setWaiting(true)), []);

  return waiting;
}

export default useUpdateWaiting;
